import { render, staticRenderFns } from "./RsaConfigurazioneLaboratoriListPage.vue?vue&type=template&id=49c52ba3"
import script from "./RsaConfigurazioneLaboratoriListPage.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneLaboratoriListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports